<template>
    <IndexBase @auth="onAuth($event)" action="SummaryReport" controller="Report"></IndexBase>

    <Card>
        <!-- <template #title>
            <div class="p-card-title center">
                SUMMARY REPORT STATUS
             </div>
        </template> -->
        <template #content>
            
            <!-- <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <div class="field grid">
                            <label for="TglBpk" class="col-2">{{$t('period')}}</label>
                                    <div class="col-3 md-3">
                                        <DatePicker name="From_Date" v-model="TglBpkFrom" :placeholder="$t('from_date')"  
                                            dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                            />
                                    </div>
                            <label for="TglBpk" class="col-2">{{$t('to')}}</label>
                                <div class="col-3 md-3">
                                     <DatePicker name="Request_Date" v-model="TglBpkTo" :placeholder="$t('to_date')" 
                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                        />
                                </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="field grid">
                            <label for="Description" class="col-2">{{ $t('desc') }}</label>
                            <div class="col-3 md-3">
                                <InputText name="PIC" type="text" v-model="Description" :placeholder="$t('desc')" :filter="true"/>
                            </div>

                            <label for="Account" class="col-2">{{ $t('account') }}</label>
                            <div class="col-3 md-3">
                                <CustomSelect class="p-inputtext-sm" :filter="true" v-model="Account"
                                :url="this.$API_URL + 'list/listAccountHRS'" :minLength="0" :params="{}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="field grid">
                            <div class="col-10 md-10">
                                <Button icon="pi pi-search" style="float:right;" class="p-button-primary p-button-sm" @click="filterDataTable"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" showGridlines filterDisplay="row" sortMode="multiple" removableSort
                       stateStorage="local"
                       :stateKey="stateKey"
                       :value="dataModel" 
                       :loading="!dataModel || loading"
                       :paginator="true"
                       :rows="10"
                       :lazy="true"
                       v-model:first="this.start"
                       @state-restore="onStateRestore($event)"
                       @page="onPage($event)"
                       @sort="onSort($event)"
                       @filter="onFilter($event)"
                       v-model:filters="filters"
                       :totalRecords="totalRecords"
                       dataKey="Id" 
                    >
                    <template #header>
                        <div class="p-card-title center mb-5">
                          {{$t('summary_report_wo')}}
                            <Button  :label="$t('export')" icon="pi pi-print" class="p-button-help p-button-sm" v-if="dataModel" @click="onExport" style="float: right;"/>
                         </div>
                        
                         <div class="p-inputtext-sm p-fluid">
                            <div class="grid">
                                <div class="col-12">
                                    <div class="grid">
                                        <div class="col-2">
                                            <span>{{$t('report_generate_date')}}</span>
                                        </div>
                                            <label for="Created_By" class="col-1">{{$t('from')}}</label>
                                            <div class="col-3 md-3">
                                                <DatePicker name="From_Date" v-model="From_Date" :placeholder="$t('from_date')"  
                                                    dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                                            </div>

                                            <label for="Created_By" class="col-1">{{$t('to')}}</label>
                                            <div class="col-3 md-3">
                                                 <DatePicker name="Request_Date" v-model="To_Date" :placeholder="$t('to_date')" 
                                                    dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"/>
                                            </div>
                                            <div class="col-2">
                                                <Button icon="pi pi-search" class="p-button-primary p-button-sm" @click="filterDataTable"/>
                                            </div>
                                        </div>
                                    
                                </div>
                                <!-- <div class="col-12">
                                    <div class="field grid">
                                        <div class="col-10 md-10">
                                            <Button icon="pi pi-search" style="float:right;" class="p-button-primary p-button-sm" @click="filterDataTable"/>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </template>
                    
                    <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                        <template #header>
                            <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                        </template>
                        <template #body="slotProps">
                           <p class="center">{{ slotProps.index +=1 }}</p> 
                         </template>
                    </Column>
                    
<!-- 
                    <Column field="No" :header="$t('no')" :sortable="false" :filter="false">
                        <template #body="slotProps">
                           {{ slotProps.index +=1 }}
                        </template>
                    </Column> -->

                    <Column field="Wo_Number" :header="$t('no_wo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_wo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="No_SPR" :header="$t('no_spr')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_spr')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    
                    <Column field="No_SPO" :header="$t('no_spo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_spo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="WBS_Allocation" :header="$t('WBS_Allocation')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('WBS_Allocation')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                      
                    <Column field="Request_Date" :header="$t('request_date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('request_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Request_Date)}}
                        </template>
                    </Column>

                    <Column field="Requester" :header="$t('requester')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('requester')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="Work_Group" :header="$t('Work_Group')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Work_Group')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="Work_Description" :header="$t('Work_Description')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Work_Description')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="PIC" :header="$t('pic')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('pic')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="Status_Release" :header="$t('Status_Release')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Status_Release')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="Pending_Release" :header="$t('Last_Pending_On')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Last_Pending_On')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="Last_Approval_Date" :header="$t('Release_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Release_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDateTime(data.Last_Approval_Date)}}
                        </template>
                    </Column>
                    
                    <Column field="Act_Start_Date" :header="$t('Act_Start_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Act_Start_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Act_Start_Date)}}
                        </template>
                    </Column>

                      
                    <Column field="Planned_Finish_Date" :header="$t('Planned_Finish_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Planned_Finish_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Planned_Finish_Date)}}
                        </template>
                    </Column>

                    <Column field="Act_Finish_Date" :header="$t('Act_Finish_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Act_Finish_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Act_Finish_Date)}}
                        </template>
                    </Column>
                  

                    <Column field="Closed_Date" :header="$t('Closed_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Closed_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Closed_Date)}}
                        </template>
                    </Column>

                    <Column field="Progress" :header="$t('Progress')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Progress')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="Status_Closing" :header="$t('Progressing_Status')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Progressing_Status')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column field="Pending_Closing" :header="$t('Last_Pending_On')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Last_Pending_On')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>


                    <Column field="Status" :header="$t('status') + '(Planned VS Actual)'" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('status')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    
            </DataTable>
        </template>
    </Card>

   
</template>

<script>
    export default {
        name: "SummaryReportWo",
        components: {
        },
        data() {
            return {
                dataModel: null,
                loading: true,
                totalRecords: 0,
                start: 0,
                stateKey: 'pas-state-summaryreportwo-' + this.$store.getters.getUsername,
                role: this.$store.getters.getRole,
                isAdmin: this.$store.getters.getIsAdmin,
                isUser: this.$store.getters.getIsUser,
                isTransporter: this.$store.getters.getIsTransporter,
                isDriver: this.$store.getters.getIsDriver,
                sorts: null,
                lazyParams: {},
                filters: null,
                stateFilters: null,
                editorPath: "/ReleaseMatrix/Editor",
                dataUrl: "Report/listsummaryreportwo",
                exportUrl : "report/exportsummaryreportwo",
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canView: false,
                changeval : null,
                From_Date : null,
                To_Date : null,
            }
        },
        methods: {
            filterDataTable(){
                localStorage.setItem('From_Date', JSON.stringify(this.From_Date));
                localStorage.setItem('To_Date',  JSON.stringify(this.To_Date));
              

                //this.$emit('block-ui');
                this.loadLazyData();
            },
            onChnageIsDeleted(event){
                this.changeval = event;
            },
            onAuth(event) {
                this.canCreate = event.canCreate;
                this.canEdit = event.canEdit;
                this.canDelete = event.canDelete;
                this.canView = event.canView;
            },
            onPage(event) {
                this.start = event.first;
                this.loadLazyData();
            },
            onSort(event) {
                this.sorts = event.multiSortMeta;
                this.loadLazyData();
            },
            onFilter() {
                this.loadLazyData();
            },
            onSelect(event){
                this.selectedRow = event.data;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            editor(mode, id) {
                this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
            },
            filter(mode) {
                this.$router.push({ path: this.filterPath, query: { mode: mode} });
            },
            sidebarMessage(event){
                this.$toast.add(event);
            },
            loadLazyData() {
                this.loading = true;
                this.selectedRow = null;
                this.From_Date = JSON.parse(localStorage.getItem('From_Date'));
                this.To_Date = JSON.parse(localStorage.getItem('To_Date'));
            
                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date
                };
            
                var self = this;
                this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                    .then((response) => {
                        if (response.data.success) {
                            this.dataModel = response.data.data;
                            this.totalRecords = response.data.totalRecords;
                        }
                        else {
                            self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        //this.$emit('unblock-ui');
                        this.loading = false;
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        //this.$emit('unblock-ui');
                        self.loading = false;
                    });
            },
            setFilters() {
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var filterValue = null;
                    if(this.stateFilters){
                        var field = this.stateFilters[exportable[i].props.field];
                        if(field) filterValue = field.value;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
            },
            onStateRestore(event) {
                this.start = event.first;
                this.stateFilters = event.filters;
                this.sorts = event.multiSortMeta;
            },
            editOrder(){
                this.$router.push({ path: this.editorPath, query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id } });
            },
             onModalClose(){
                this.loadLazyData();
            },
            clearFilter(){
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                this.changeval = null;
                
                localStorage.setItem('From_Date', null);
                localStorage.setItem('To_Date',  null);

                for (var i = 0; i < exportable.length; i++) {
                    var fieldName = exportable[i].props.field;
                    var filterValue = "";
                    if(fieldName.includes("Date") || fieldName.includes("Start_Work") || fieldName.includes("Finish_Work")){
                        filterValue = null;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
                this.loadLazyData();
            },
            onExport(){
                this.loading = true;
                this.selectedRow = null;
                this.From_Date = JSON.parse(localStorage.getItem('From_Date'));
                this.To_Date = JSON.parse(localStorage.getItem('To_Date'));

                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date
                };

                var self = this;

                this.$axios.post(this.$API_URL + this.exportUrl, this.lazyParams, {
                    responseType: 'blob',
                    timeout: this.$AXIOS_TIMEOUT_LONG
                    })
                    .then((response) => {
                        var contentDisposition = response.headers["content-disposition"];
                        var matchName = contentDisposition.match(/filename\s*=\s*"?(.+)"?/);
                        var filename = matchName[1].split(';')[0];
                        
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 60000});
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            }
        },
        mounted() {
            this.$emit('unblock-ui');
            this.setFilters();
            this.loadLazyData();
            this.$showToast();
        },
        computed: {
            dataFilter() {
                var h = [];
                if (this.filters) {
                    for (const [key, value] of Object.entries(this.filters)) {
                        h.push({
                            field: key ? key : null,
                            value: value.value,
                            matchMode: value.matchMode
                        });
                    }
                }
                return h;
            },
            dataSort() {
                var h = [];
                if (this.sorts) {
                    for (var x = 0; x < this.sorts.length; x++) {
                        h.push({
                            field: this.sorts[x].field,
                            order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                        });
                    }
                }
                return h;
            },
            filterBadge(){
                var badgeNumber = 0;

                if(this.From_Date!=null) badgeNumber+=1;
                if(this.To_Date!=null) badgeNumber+=1;

                this.dataFilter.filter(function(item) {                    
                    if(item.value){
                        badgeNumber++;
                    }
                });

                return badgeNumber;
            }
        },
    }
</script>

<style #scoped>
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }
    .center{
        text-align: center;
    }
</style>